function init(anchor) {

    console.log('cta modal init')
    console.log(anchor);

    $(`a#btnPrint-${anchor}`).click(function () {
        $(`#${anchor}`).print();
    });

}

export default {
    init
}